import { aiFetch as fetchData } from '@/utils/aiFetch'
import { formatDate } from '@/utils/utils'

export const retrieveDeepSearchList = (data) => {
  return fetchData('/deep_search', {
    method: 'post',
    body: JSON.stringify({
      ...data,
      current_time: formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
    })
  })
}

export const deepSearchFeedback = (data) => {
  return fetchData('/feedback', {
    method: 'post',
    body: JSON.stringify({
      ...data,
      current_time: formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
    })
  })
}
